<template>
  <v-dialog
    v-model="dialog"
    width="800px"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary" class="mr-2" v-if="!single" dark>
        <v-icon left>mdi-account-edit</v-icon>Sửa Nhóm
      </v-btn>
      <v-list-item v-on="on" class="py-1" v-if="single">
        <v-list-item-icon class="mr-2"
          ><v-icon left>mdi-account-edit</v-icon></v-list-item-icon
        >
        <v-list-item-content>Sửa nhóm</v-list-item-content>
      </v-list-item>
    </template>
    <v-card>
      <v-card-title class="amber darken-1 white--text"
        >Sửa nhóm
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <p class="mt-4 text-subtitle-1 font-weight-bold">Nhập tên nhóm mới</p>
        <v-text-field
          :disabled="loading"
          :rules="[rules.required]"
          v-model="tags"
          label="Tên nhóm mới"
          outlined
          dense
        ></v-text-field>
        <small v-if="students">{{ students.length }} Học sinh được chọn</small>
        <v-data-table
          item-key="id"
          :headers="headers"
          :items="students"
          :items-per-page="10"
          dense
        >
          <template v-slot:item.index="{ item }">
            <span>{{ students.indexOf(item) + 1 }}</span>
          </template>
          <template v-slot:item.name="{ item }">
            <span>{{ item.name }}</span>
          </template>
          <template v-slot:item.generation="{ item }">
            <span style="white-space: nowrap;">{{
              item.generation ? item.generation.code : ''
            }}</span>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="mr-4 mt-n6 mb-4"
          color="primary"
          @click="save"
          depressed
          :loading="loading"
          >Lưu</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
export default {
  components: {},
  data() {
    return {
      dialog: false,
      loading: false,
      tags: '',
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 6 || 'Min 8 characters',
        email: v => /.+@.+/.test(v) || 'E-mail must be valid'
      },
      headers: [
        { text: 'STT', value: 'index', align: 'left', sortable: false },
        { text: 'Tên', value: 'name', align: 'left', sortable: false },
        { text: 'Khóa', value: 'generation', align: 'left', sortable: false },
        { text: 'Nhóm', value: 'tags', align: 'left', sortable: false },
        { text: 'Email', value: 'email', align: 'left', sortable: false },
        {
          text: 'Số Điện Thoại',
          value: 'phone',
          align: 'left',
          sortable: false
        }
      ]
    }
  },
  props: {
    state: Boolean,
    students: Array,
    single: { type: Boolean, default: false }
  },
  computed: {
    ...mapState('app', ['roles', 'department']),
    ...mapGetters('app', ['roleIdByName', 'roles'])
  },
  created() {},
  methods: {
    ...mapActions('user', ['generateUserName', 'validateEmail']),
    ...mapActions('students', ['updateStudents']),
    async save() {
      this.loading = true
      await this.updateStudents(
        this.students.map(s => ({
          id: s.id,
          tags: this.tags
        }))
      )
      this.loading = false
      this.dialog = false
      this.reset()
    },

    cancel() {
      this.dialog = false
      this.reset()
    },
    reset() {
      this.tags = ''
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
